import { CSSProperties } from 'react';
import { Button } from '@mui/material';
import './styles/icon-button.css';

interface IconButtonComponentProps {
    label: string;
    icon: React.ReactNode;
    onClick: () => void;
    disabled?: boolean;
    styles?: CSSProperties;
}

export default function IconButtonComponent({ 
    label, 
    icon, 
    onClick, 
    disabled = false, 
    styles 
}: IconButtonComponentProps) {
    return (
        <Button
            className="icon-button-custom"
            onClick={onClick}
            disabled={disabled}
            style={styles}
            startIcon={icon}
        >
            {label}
        </Button>
    );
}